// @todo esportare e verificare se valido per tutti gli ambienti
export const urlRegExp = /https:\/\/exelio-gpexe-(.*)-data\.s3(\.[\w-]+)?\.amazonaws\.com(\.cn)?\/(.*)\/(.\d{2,})\/(.\d{2,}).gbf/;
export const URL_REGEXP_ATHID = 6; // in base alla regexp sopra indica quale è la posizione della athleteSession id

export const SLOT_DURATION = 300000; // 5 minuti in s

export const BLOCK_MS = 5 * 60 * 10000;
export const STORE_NAME = 'session-data-state';
